"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSerializeCall = void 0;
const react_1 = require("react");
const deferred_1 = require("./deferred");
const event_callback_hook_1 = require("./event-callback-hook");
/**
 * Call serializer hook.
 *
 * Provides the caller with methods to enqueue and finish async calls.
 * Useful when the calls are depending on the state change from the previous one.
 *
 *
 * @param onCall onCall callback
 */
function useSerializeCall(onCall) {
    const callsQueue = react_1.useRef([]);
    /**
     * Adds calls to queue.
     */
    const enqueueCall = event_callback_hook_1.useEventCallback(async function () {
        // Enqueues new call
        const call = new deferred_1.Deferred();
        callsQueue.current.push(call);
        if (callsQueue.current.length === 1) {
            // if there is only this one call enqueued, start processing
            while (callsQueue.current.length > 0) {
                // processes every call one by one removing it from the queue
                // we can not call callsQueue.current.pop() because new call can be enqueued during onCall async processing,
                // therefore we will call callsQueue.current.shift() to remove processed call from queue only after the processing is completed
                const call = callsQueue.current[0];
                try {
                    await onCall();
                    call.resolve();
                    callsQueue.current.shift();
                }
                catch (err) {
                    // rejects all outstanding calls with the same error
                    callsQueue.current.forEach((call) => call.reject(err));
                }
            }
        }
        return call.promise;
    });
    return [enqueueCall];
}
exports.useSerializeCall = useSerializeCall;
//# sourceMappingURL=serialize-call-hook.js.map